import { render, staticRenderFns } from "./PageColumnsConfig.vue?vue&type=template&id=3f25d6f4"
import script from "./PageColumnsConfig.vue?vue&type=script&lang=js"
export * from "./PageColumnsConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports